import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import { configSelector } from "redux/selectors/config";
import { fetchCurrentNotification } from "redux/actions/currentNotificationActions";
import { fetchMission } from "redux/actions/missionActions";
import { getCaseStart } from "redux/actions/caseActions";

export const useLoadCaseOrMissionData = () => {
  const dispatch = useDispatch();
  const config = useSelector(configSelector);
  const {
    case: { show_case_page },
    config_file
  } = config;
  const {
    params: { id }
  } = useRouteMatch();
  const getCase = useCallback(({ id }) => dispatch(getCaseStart({ id })), [
    dispatch
  ]);
  const getMission = useCallback(
    ({ id, config_file }) => dispatch(fetchMission({ id, config_file })),
    [dispatch]
  );
  const getCurrentNotification = useCallback(
    ({ id, config_file }) =>
      dispatch(fetchCurrentNotification({ id, config_file })),
    [dispatch]
  );
  useEffect(() => {
    if (show_case_page) {
      getCase({ id, config_file });
    } else {
      getMission({ id, config_file });
      getCurrentNotification({ id, config_file });
    }
  }, [
    config_file,
    id,
    show_case_page,
    getCase,
    getMission,
    getCurrentNotification
  ]);
};
